import React, { useEffect, useState } from 'react';
import './GameElements.css';

export const FeedbackOverlay = ({ isCorrect, show }) => {
  if (!show) return null;
  
  return (
    <div className={`feedback-overlay ${isCorrect ? 'correct' : 'incorrect'}`}>
      <div className="feedback-icon">
        {isCorrect ? '✅' : '❌'}
      </div>
    </div>
  );
};

export const ProgressBar = ({ current, total }) => {
  const progress = (current / total) * 100;
  
  const styles = {
    container: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: '2px',
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      overflow: 'hidden',
      zIndex: 1000,
    },
    bar: {
      height: '100%',
      background: 'linear-gradient(to right, rgba(76, 175, 80, 0.3), rgba(76, 175, 80, 0.8))',
      width: `${progress}%`,
      transition: 'width 0.5s ease',
      boxShadow: '0 0 8px rgba(76, 175, 80, 0.3)',
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.bar} />
    </div>
  );
};

export const ScoreDisplay = ({ score, className }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
    const timer = setTimeout(() => setAnimate(false), 500);
    return () => clearTimeout(timer);
  }, [score]);

  return (
    <div className={`${className} ${animate ? 'score-animation' : ''}`}>
      {score}
    </div>
  );
};

export const Rewards = ({ score }) => {
  const medals = [
    { threshold: 50, icon: '🥉', label: 'Bronze' },
    { threshold: 100, icon: '🥈', label: 'Silver' },
    { threshold: 200, icon: '🥇', label: 'Gold' },
    { threshold: 500, icon: '👑', label: 'Crown' }
  ];

  const currentMedal = medals.filter(medal => score >= medal.threshold).pop();

  if (!currentMedal) return null;

  return (
    <div className="reward-badge" title={`${currentMedal.label} Achievement`}>
      {currentMedal.icon}
    </div>
  );
};
